declare namespace $ {

	type $mol_button_minor__title_shm_hitalama_map_widget_float_table2_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table2['entity_schema_title'] >
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_widget_float_table2_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table2['entity_schema_open'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_download__title_shm_hitalama_map_widget_float_table2_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_download['title'] >
	>
	type $mol_button_download__blob_shm_hitalama_map_widget_float_table2_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table2['csv_blob'] >
		,
		ReturnType< $mol_button_download['blob'] >
	>
	type $mol_button_download__file_name_shm_hitalama_map_widget_float_table2_5 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table2['csv_file_name'] >
		,
		ReturnType< $mol_button_download['file_name'] >
	>
	type $mol_button_minor__title_shm_hitalama_map_widget_float_table2_6 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table2['cell_atom_link_label'] >
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__sub_shm_hitalama_map_widget_float_table2_7 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table2['cell_atom_link_content'] >
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_widget_float_table2_8 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table2['cell_atom_link_open'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__attr_shm_hitalama_map_widget_float_table2_9 = $mol_type_enforce<
		({ 
			'selected': ReturnType< $shm_hitalama_map_widget_float_table2['cell_atom_link_current'] >,
		})  & ReturnType< $mol_button_minor['attr'] >
		,
		ReturnType< $mol_button_minor['attr'] >
	>
	type $mol_select__value_shm_hitalama_map_widget_float_table2_10 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table2['cell_atom_link'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_select__dictionary_shm_hitalama_map_widget_float_table2_11 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table2['cell_link_options'] >
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_select__trigger_content_shm_hitalama_map_widget_float_table2_12 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_select['trigger_content'] >
	>
	type $mol_button_minor__title_shm_hitalama_map_widget_float_table2_13 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_widget_float_table2_14 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table2['cell_relation_create'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_shm_hitalama_map_widget_float_table2_15 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_table2_16 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_hitalama_map_widget_float_table2_link_list__table2_shm_hitalama_map_widget_float_table2_17 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table2['table_self'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table2_link_list['table2'] >
	>
	type $shm_hitalama_map_widget_float_table2_link_list__cell_id_shm_hitalama_map_widget_float_table2_18 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table2['list_cell_id'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table2_link_list['cell_id'] >
	>
	type $shm_hitalama_map_widget_float_table2_link_list__options_shm_hitalama_map_widget_float_table2_19 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table2['cell_list_option_ids'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table2_link_list['options'] >
	>
	type $shm_hitalama_map_widget_float_table2_link_list__value_shm_hitalama_map_widget_float_table2_20 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table2['cell_list_picker_value'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table2_link_list['value'] >
	>
	type $mol_pick__trigger_content_shm_hitalama_map_widget_float_table2_21 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['trigger_content'] >
	>
	type $mol_pick__bubble_content_shm_hitalama_map_widget_float_table2_22 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['bubble_content'] >
	>
	type $mol_button_minor__title_shm_hitalama_map_widget_float_table2_23 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_widget_float_table2_24 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table2['cell_relation_create'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_shm_hitalama_map_widget_float_table2_25 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__attr_shm_hitalama_map_widget_float_table2_26 = $mol_type_enforce<
		({ 
			'selected': ReturnType< $shm_hitalama_map_widget_float_table2['cell_relation_create_current'] >,
		})  & ReturnType< $mol_button_minor['attr'] >
		,
		ReturnType< $mol_button_minor['attr'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_table2_27 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_select__value_shm_hitalama_map_widget_float_table2_28 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table2['cell_select'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_select__dictionary_shm_hitalama_map_widget_float_table2_29 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table2['cell_select_options'] >
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_select__Filter_shm_hitalama_map_widget_float_table2_30 = $mol_type_enforce<
		any
		,
		ReturnType< $mol_select['Filter'] >
	>
	type $shm_hitalama_map_widget_float_table2_relation_form__table_shm_hitalama_map_widget_float_table2_31 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table2['table_self'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table2_relation_form['table'] >
	>
	type $shm_hitalama_map_widget_float_table2_relation_form__table2_shm_hitalama_map_widget_float_table2_32 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table2['table_self'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table2_relation_form['table2'] >
	>
	type $shm_hitalama_map_widget_float_table2_relation_form__page_index_shm_hitalama_map_widget_float_table2_33 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table2['relation_page_index'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table2_relation_form['page_index'] >
	>
	type $shm_hitalama_map_widget_float_table_select__value_shm_hitalama_map_widget_float_table2_34 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table2['inverse_field'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table_select['value'] >
	>
	type $shm_hitalama_map_widget_float_table_select__dictionary_shm_hitalama_map_widget_float_table2_35 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table2['inverse_field_options'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table_select['dictionary'] >
	>
	type $shm_hitalama_map_widget_float_table_select__Filter_shm_hitalama_map_widget_float_table2_36 = $mol_type_enforce<
		any
		,
		ReturnType< $shm_hitalama_map_widget_float_table_select['Filter'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_table2_37 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__attr_shm_hitalama_map_widget_float_table2_38 = $mol_type_enforce<
		({ 
			'broken': ReturnType< $shm_hitalama_map_widget_float_table2['broken_record_notice'] >,
		})  & ReturnType< $mol_view['attr'] >
		,
		ReturnType< $mol_view['attr'] >
	>
	type $shm_hitalama_map_widget_float_table2_col_name__value_shm_hitalama_map_widget_float_table2_39 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table2['col_name_draft'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table2_col_name['value'] >
	>
	type $shm_hitalama_map_widget_float_table2_col_name__commit_shm_hitalama_map_widget_float_table2_40 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table2['col_name_commit'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table2_col_name['commit'] >
	>
	type $mol_grid_cell__sub_shm_hitalama_map_widget_float_table2_41 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_grid_cell['sub'] >
	>
	type $mol_grid_cell__style_shm_hitalama_map_widget_float_table2_42 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table2['cell_style'] >
		,
		ReturnType< $mol_grid_cell['style'] >
	>
	type $mol_grid_cell__sub_shm_hitalama_map_widget_float_table2_43 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_grid_cell['sub'] >
	>
	type $mol_grid_cell__style_shm_hitalama_map_widget_float_table2_44 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table2['cell_style'] >
		,
		ReturnType< $mol_grid_cell['style'] >
	>
	type $mol_grid_cell__sub_shm_hitalama_map_widget_float_table2_45 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_grid_cell['sub'] >
	>
	type $mol_grid_cell__style_shm_hitalama_map_widget_float_table2_46 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table2['cell_style'] >
		,
		ReturnType< $mol_grid_cell['style'] >
	>
	type $mol_button_minor__title_shm_hitalama_map_widget_float_table2_47 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table2['cell_list_item_label'] >
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__sub_shm_hitalama_map_widget_float_table2_48 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table2['cell_list_item_content'] >
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_widget_float_table2_49 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table2['cell_list_item_open'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__attr_shm_hitalama_map_widget_float_table2_50 = $mol_type_enforce<
		({ 
			'selected': ReturnType< $shm_hitalama_map_widget_float_table2['cell_list_item_current'] >,
		})  & ReturnType< $mol_button_minor['attr'] >
		,
		ReturnType< $mol_button_minor['attr'] >
	>
	type $mol_button_minor__title_shm_hitalama_map_widget_float_table2_51 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_widget_float_table2_52 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table2['cell_list_more'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_table2_53 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_labeler__title_shm_hitalama_map_widget_float_table2_54 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_hitalama_map_widget_float_table2_55 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table2['Inverse_field'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_string__hint_shm_hitalama_map_widget_float_table2_56 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_shm_hitalama_map_widget_float_table2_57 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table2['inverse_field_name'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_button_minor__title_shm_hitalama_map_widget_float_table2_58 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_widget_float_table2_59 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table2['inverse_field_create'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__enabled_shm_hitalama_map_widget_float_table2_60 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table2['inverse_field_create_enabled'] >
		,
		ReturnType< $mol_button_minor['enabled'] >
	>
	export class $shm_hitalama_map_widget_float_table2 extends $shm_hitalama_map_widget_float_table {
		entity_schema_title( ): string
		entity_schema_open( next?: any ): any
		Entity_schema( ): $mol_button_minor
		csv_blob( ): $mol_blob
		csv_file_name( ): string
		Csv_download( ): $mol_button_download
		broken_record_notice( ): boolean
		col_name_draft( id: any, next?: string ): string
		col_name_commit( id: any, next?: any ): any
		cell_atom_link_label( id: any): string
		cell_atom_link_content( id: any): readonly(any)[]
		cell_atom_link_open( id: any, next?: any ): any
		cell_atom_link_current( id: any): boolean
		Atom_link_item( id: any): $mol_button_minor
		atom_link_item_visible( id: any): readonly(any)[]
		cell_atom_link( id: any, next?: string ): string
		cell_link_options( id: any): Record<string, any>
		Atom_link_pick_icon( id: any): $mol_icon_dots_vertical
		Atom_link_pick( id: any): $mol_select
		cell_relation_create( id: any, next?: any ): any
		Atom_link_create_icon( id: any): $mol_icon_plus
		Atom_link_create( id: any): $mol_button_minor
		Atom_link_content( id: any): $mol_view
		List_link_pick_icon( id: any): $mol_icon_dots_vertical
		cell_list_option_ids( id: any): readonly(string)[]
		cell_list_picker_value( id: any, next?: readonly(string)[] ): readonly(string)[]
		List_link_options( id: any): $shm_hitalama_map_widget_float_table2_link_list
		List_link_pick( id: any): $mol_pick
		List_link_create_icon( id: any): $mol_icon_plus
		cell_relation_create_current( id: any): boolean
		List_link_create( id: any): $mol_button_minor
		cell_list_item_views( id: any): readonly($mol_view)[]
		List_link_content( id: any): $mol_view
		cell_select( id: any, next?: string ): string
		cell_select_options( id: any): Record<string, any>
		Select_value( id: any): $mol_select
		cell_list_item_label( id: any): string
		cell_list_item_content( id: any): readonly(any)[]
		cell_list_item_open( id: any, next?: any ): any
		cell_list_item_current( id: any): boolean
		cell_list_more( id: any, next?: any ): any
		relation_page_index( id: any): number
		Relation_edit_form( id: any): $shm_hitalama_map_widget_float_table2_relation_form
		inverse_field( id: any, next?: string ): string
		inverse_field_options( id: any): Record<string, any>
		Inverse_field( id: any): $shm_hitalama_map_widget_float_table_select
		inverse_field_name( id: any, next?: string ): string
		inverse_field_create( id: any, next?: any ): any
		inverse_field_create_enabled( id: any): boolean
		contextmenu_body( ): readonly(any)[]
		Query_status( ): $mol_view
		Col_name( id: any): $shm_hitalama_map_widget_float_table2_col_name
		list_cell_id( id: any): any
		Cell_atom_link( id: any): $mol_grid_cell
		Cell_list_link( id: any): $mol_grid_cell
		Cell_select( id: any): $mol_grid_cell
		List_link_item( id: any): $mol_button_minor
		List_link_more( id: any): $mol_button_minor
		Relation_edit_panel( id: any): $mol_view
		Inverse_field_label( id: any): $mol_labeler
		Inverse_field_name( id: any): $mol_string
		Inverse_field_create( id: any): $mol_button_minor
	}
	
	export class $shm_hitalama_map_widget_float_table2_relation_form extends $shm_hitalama_map_widget_float_table_form {
		table2( ): any
		page_index( ): number
	}
	
	export class $shm_hitalama_map_widget_float_table2_col_name extends $shm_hitalama_map_widget_float_table_col_name {
	}
	
	type $mol_check_box__title_shm_hitalama_map_widget_float_table2_link_list_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table2_link_list['check_title'] >
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_shm_hitalama_map_widget_float_table2_link_list_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table2_link_list['checked'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_check_box__sub_shm_hitalama_map_widget_float_table2_link_list_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table2_link_list['check_content'] >
		,
		ReturnType< $mol_check_box['sub'] >
	>
	export class $shm_hitalama_map_widget_float_table2_link_list extends $shm_check_list {
		check_content( id: any): readonly(any)[]
		table2( ): any
		cell_id( ): any
		Check( id: any): $mol_check_box
	}
	
}

//# sourceMappingURL=table2.view.tree.d.ts.map